import React from 'react';

// tslint:disable max-line-length
const RIntroContentLocalMuseumTranscriptionBrighton: React.FC = () => (
  <>
    <h5>Introduction</h5>
    <p>Hey. So you’ve come to the museum. This gift has been made... for you. I’ll explain. Someone here wanted to share the objects in this gift with you and recorded messages for each one. Walk around and see if you can find the first one. If you get stuck, show the photo to a member of staff. Someone’s gonna know where it is. I’ll see you on the other side.</p>
  </>
);

export {
  RIntroContentLocalMuseumTranscriptionBrighton,
};
